import { render, staticRenderFns } from "./notice_article.vue?vue&type=template&id=3d77d8da&scoped=true&"
import script from "./notice_article.vue?vue&type=script&lang=js&"
export * from "./notice_article.vue?vue&type=script&lang=js&"
import style0 from "./notice_article.vue?vue&type=style&index=0&id=3d77d8da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77d8da",
  null
  
)

export default component.exports